import React, { useState } from 'react';
import {
	Input,
	Button,
	Spin,
	Typography,
	Alert,
	Form,
	Layout,
	notification,
} from 'antd';
import axios, { AxiosError } from 'axios';

const { Title } = Typography;
const { TextArea } = Input;
const { Content } = Layout;

interface IErrorState {
	message: string;
	status?: number;
	data?: any;
	details?: string;
}

const ApiTestTool: React.FC = () => {
	const [url, setUrl] = useState<string>('');
	const [headers, setHeaders] = useState<string>('{}');
	const [loading, setLoading] = useState<boolean>(false);
	const [response, setResponse] = useState<any>(null);
	const [error, setError] = useState<IErrorState | null>(null);

	const handleSubmit = async () => {
		setLoading(true);
		setResponse(null);
		setError(null);

		let parsedHeaders: Record<string, string> = {};

		try {
			parsedHeaders = JSON.parse(headers);
		} catch (jsonErr) {
			notification.error({
				message: 'Invalid Headers',
				description: 'Headers deve ser um JSON válido.',
			});
			setLoading(false);
			setError({ message: 'Headers deve ser um JSON válido.' });
			return;
		}

		try {
			const res = await axios.get(url, {
				headers: parsedHeaders,
			});
			setResponse(res.data);
		} catch (err) {
			const axiosError = err as AxiosError;
			if (axiosError.response) {
				setError({
					message: axiosError.message,
					status: axiosError.response.status,
					data: axiosError.response.data,
				});
			} else if (axiosError.request) {
				setError({
					message: axiosError.message,
					details:
						'Sem resposta. Verifique o console do browser para erros de CORS.',
				});
			} else {
				setError({ message: axiosError.message });
			}
		} finally {
			setLoading(false);
		}
	};

	return (
		<Content style={{ padding: '24px', backgroundColor: '#fff' }}>
			<Title level={2}>API GET Request Test Tool</Title>
			<Form layout="vertical" onFinish={handleSubmit}>
				<Form.Item
					label="URL Completa"
					tooltip="Digite a URL completa para a requisição GET."
				>
					<Input
						placeholder="https://..."
						value={url}
						onChange={e => setUrl(e.target.value)}
					/>
				</Form.Item>

				<Form.Item
					label="Request Headers (formato JSON)"
					tooltip='Entre com os dados da Header em formato JSON. Examplo: { "Authorization": "Bearer ...", "x-api-key": "..." }'
				>
					<TextArea
						rows={4}
						value={headers}
						onChange={e => setHeaders(e.target.value)}
						placeholder='{ "Authorization": "Bearer ..." }'
					/>
				</Form.Item>

				<Form.Item>
					<Button type="primary" htmlType="submit" loading={loading}>
						GET Request
					</Button>
				</Form.Item>
			</Form>

			{loading && <Spin tip="Loading..." />}

			{error && (
				<>
					<Title level={4}>Error</Title>
					<Alert
						message={`Request Failed: ${error.message}`}
						description={
							<pre>
								{JSON.stringify(
									{
										status: error.status,
										details: error.details,
										responseData: error.data,
									},
									null,
									2,
								)}
							</pre>
						}
						type="error"
						showIcon
					/>
				</>
			)}

			{response && (
				<>
					<Title level={4}>Success Response</Title>
					<Alert
						message="Request Successful"
						description={<pre>{JSON.stringify(response, null, 2)}</pre>}
						type="success"
						showIcon
					/>
				</>
			)}
		</Content>
	);
};

export default ApiTestTool;
